import request from '../utils/request'
import { LIST_LEAD, LIST_TASK } from './LeadConstants'


export const listLead = (date = undefined) => {
    return {
        type: LIST_LEAD,
        payload: request.get('provider/?type=lead'+(date ? "&date="+date : ''))
    }
};

export const listRefusal = () => {
    return {
        type: LIST_LEAD,
        payload: request.get('provider/?type=refusal')
    }
};

export const listLastLead = (region) => {
    return {
        type: LIST_LEAD,
        payload: request.get('provider/?type=last'+(region ? '&region='+region : '' ))
    }
};

export const listTask = (region=null, date=null) => {
    return {
        type: LIST_TASK,
        payload: request.get('provider/?type=task'+(region ? '&region='+region : '' )+(date ? "&date="+date : ''))
    }
};




// WEBPACK FOOTER //
// ./src/lead/LeadActions.js